import { render, staticRenderFns } from "./Kernel.vue?vue&type=template&id=cee021ac&scoped=true&"
import script from "./Kernel.vue?vue&type=script&lang=ts&"
export * from "./Kernel.vue?vue&type=script&lang=ts&"
import style0 from "./Kernel.vue?vue&type=style&index=0&id=cee021ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee021ac",
  null
  
)

export default component.exports